/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button, { ButtonProps } from './Button';

import styles from '../../../styles/buttons/styled-button.module.scss';

export interface StyledButtonProps extends ButtonProps {
    colored?: boolean;
    bordered?: boolean;
    size?: string;
}

function StyledButton({
    colored = false,
    bordered = false,
    size = null,
    disabled = false,
    className = null,
    ...props
}: StyledButtonProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <Button
            className={classNames([
                styles.container,
                themeClassName,
                className,
                {
                    [styles[size]]: size !== null,
                    [styles.bordered]: bordered,
                    [styles.colored]: colored,
                    [styles.disabled]: disabled,
                },
            ])}
            disabled={disabled}
            {...props}
        />
    );
}

export default StyledButton;
